import { GetEmployeeProfilesQueryProps } from "Shared/types/EmployeeProfiles";
import { UserTableSort } from "Shared/types/Sort";

export default function propsToQuery({
  page,
  search,
  userStatusFilters,
  locationFilters,
  payGroupFilters,
  employmentStatusFilters,
  benefitFilters,
  sort,
}: GetEmployeeProfilesQueryProps) {
  const queryString =
    "?" +
    [
      `page=${page}`,
      searchToString(search),
      advancedFiltersToString(userStatusFilters, "userStatus"),
      advancedFiltersToString(locationFilters, "location"),
      advancedFiltersToString(payGroupFilters, "payGroup"),
      advancedFiltersToString(employmentStatusFilters, "employmentStatus"),
      advancedFiltersToString(benefitFilters, "benefitType"),
      sortToString(sort),
    ]
      .filter(s => s)
      .join("&");

  return queryString;
}

function searchToString(search: string) {
  return search ? `search=${encodeURIComponent(search)}` : "";
}

function advancedFiltersToString(
  filters: string[],
  filterType: string
) {
  if (filters.length) {
    return `${filterType}=${filters.join(",")}`;
  } else {
    return "";
  }
}

function sortToString(sort: UserTableSort) {
  return `sort=${sort.join(",")}`;
}
